<template>
  <div>
    <DropDownList
      :classNames="classNames"
      :isLargeDropDown="false"
      itemSection="Item Table Action Bar"
      :menuSections="searchContextMenuSections"
      menuFontSize="small"
      :showList="showList"
      :showMenuLabel="true"
    />
  </div>
</template>

<script>
import { SystemSearchConsts } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import DropDownList from 'client/components/DropDownMenu/DropDownList.vue';

const {
  displayName,
  hostname,
  version,
  arch,
  amazonInstanceID,
  systemID,
  mdmDeviceID,
  agentVersion,
  serialNumber,
  remoteIP,
} = SystemSearchConsts;

export default {
  name: 'SystemSearchFilter',

  components: {
    DropDownList,
  },

  props: {
    setSearchInputValue: {
      type: Function,
      required: true,
    },
    showList: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    const searchContextMenuSections = [
      {
        menuLabel: 'search this list on:',
        menuItems: [
          {
            label: `${displayName}:`,
            exampleText: 'xxxxx',
            action: () => this.setSearchInputValue(`${displayName}: `),
          },
          {
            label: `${hostname}:`,
            exampleText: 'xxxxx',
            action: () => this.setSearchInputValue(`${hostname}: `),
          },
          {
            label: `${version}:`,
            exampleText: 'xx.xx.xx',
            action: () => this.setSearchInputValue(`${version}: `),
          },
          {
            label: `${arch}:`,
            exampleText: 'xxxxx',
            action: () => this.setSearchInputValue(`${arch}: `),
          },
          {
            label: `${amazonInstanceID}:`,
            exampleText: 'x-xxxxxxxxxxxxxxxxx',
            action: () => this.setSearchInputValue(`${amazonInstanceID}: `),
          },
          {
            label: `${systemID}:`,
            exampleText: 'xxxxxxxxxxxxxxxxxxxxx',
            action: () => this.setSearchInputValue(`${systemID}: `),
          },
          {
            label: `${mdmDeviceID}:`,
            exampleText: 'xxxxxxxxxxxxxxxxxxxxxxxx',
            action: () => this.setSearchInputValue(`${mdmDeviceID}: `),
          },
          {
            label: `${agentVersion}:`,
            exampleText: 'x.xx.xx',
            action: () => this.setSearchInputValue(`${agentVersion}: `),
          },
          {
            label: `${serialNumber}:`,
            exampleText: 'xxxxxxxxxxxx',
            action: () => this.setSearchInputValue(`${serialNumber}: `),
          },
          {
            label: `${remoteIP}:`,
            exampleText: 'xx.xxx.xx.x',
            action: () => this.setSearchInputValue(`${remoteIP}: `),
          },
        ],
      },
    ];

    const classNames = {
      dropDownList: 'searchContext',
    };

    return {
      classNames,
      searchContextMenuSections,
    };
  },

  computed: {
    ...mapGetters('SystemCollection', {
      searchTerm: 'getSearchTerm',
    }),
  },

  watch: {
    showList() {
      if (this.showList) {
        const searchString = this.searchTerm || '';
        // show helper text when the input is clicked
        this.setSearchInputValue(searchString);
      }
    },
  },

  methods: {
    ...mapActions('SystemCollection', [
      'setFilter',
    ]),
  },
};
</script>
